// This is intended. This is a no-op function and intended to do nothing.
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noOp: () => void = () => {};

export default noOp;
